export default __webpack_public_path__ + "static/slider.dibk.klein-952347595d35c24a691451b3dd6c984b.jpg";